import { isProdBEnv } from '@/utils/isProdBEnv';

/** 后台左上角 / 登录页品牌名 */
export function getAdminBrandTitle(): string {
  return isProdBEnv() ? '医美管理' : '教育管理';
}

/** 兼容旧用法：模块加载时就算一次；prod-b 以 isProdBEnv / __ADMIN_IS_PROD_B__ 为准 */
export const adminBrandTitle = getAdminBrandTitle();
